import api from '../../utils/api';
import {
    GET_LIST_CUSTOMER_STATUS,
    GET_SPECIFIC_CUSTOMER_STATUS,
    UPDATE_SPECIFIC_CUSTOMER_STATUS,
    CREATE_NEW_CUSTOMER_STATUS,
    REMOVE_CUSTOMER_STATUS,
    GET_CUSTOMER_STATUS_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListCustomerStatus = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/customer-status', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_CUSTOMER_STATUS, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getSpecificCustomerStatus = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/customer-status/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_CUSTOMER_STATUS, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getCustomerStatusActive = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/customer-status/by-active', { params: filter }).then(res => {
            //console.log(res)
            dispatch({ type: GET_CUSTOMER_STATUS_ACTIVE, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createCustomerStatus = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/customer-status', data).then(res => {
            dispatch({ type: CREATE_NEW_CUSTOMER_STATUS, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}



export const updateCustomerStatus = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/customer-status/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_CUSTOMER_STATUS, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeCustomerStatus = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/customer-status`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_CUSTOMER_STATUS, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}
